.folder-container {
  height: 100%;
  position: relative;
}

.uploaded-file-info {
  display: flex;
  border-radius: 0.4rem;
  height: 5.6rem;
  cursor: pointer;
  background-color: #367bff33;
  border: 1px solid;
  border-color: var(--color-primary-crayola);

  &[data-dashed='true'] {
    border: 1px dashed;
  }
}

.placeholder {
  font-size: 1.6rem;
  color: var(--color-primary-crayola);
  font-weight: 400;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.3rem;
}

.preview {
  height: 100%;
  object-fit: cover;
  border-radius: 0.8rem;
}
